///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { useState } from "react";
import Tippy from "@tippyjs/react";

import VerticalMenuIcon from "../../icons/VerticalMenuIcon";
import messages from "../../../helpers/messages";

export const MenuDropdown = ({
  clearSelectedMatches,
  editMatches,
  disabled,
  copyMatches
}) => {
  const [filter, toggleFilter] = useState(false);

  const Menu = () => {
    return (
      <div className="card cursor-pointer font-size-14" id="menu-dropdown">
        <ul className="mb-0">
          <li className="px-16 pt-16 pb-12" onClick={editMatches}>
            {messages.editMatches.defaultMessage}
          </li>
          <li className="px-16 pt-12 pb-12" onClick={copyMatches}>
            {messages.copyMatchesToLane.defaultMessage}
          </li>
          <li className="px-16 pt-12 pb-16" onClick={clearSelectedMatches}>
            {messages.clearSelectedMatches.defaultMessage}
          </li>
        </ul>
      </div>
    );
  };

  return (
    <Tippy
      appendTo="parent"
      content={<Menu />}
      placement="bottom-end"
      interactive={true}
      visible={filter}
      onClickOutside={() => toggleFilter(false)}
      offset={[-6, 3]}
      delay={0}
    >
      <button
        className="menu cursor-pointer inline-block mr-8 fr"
        data-testid="menu"
        onClick={() => toggleFilter(filter === false)}
        disabled={disabled}
      >
        <VerticalMenuIcon
          height="16px"
          width="16px"
          fill={`${disabled ? "#7c7c7c" : "#0C1826"} `}
        />
      </button>
    </Tippy>
  );
};

export default MenuDropdown;
